var _react_refresh_temp_1;
var _react_refresh_temp_2;
_react_refresh_temp_2 = $RefreshSig$();
import { jsx as _jsx } from "react/jsx-runtime";
import { Navigate, useParams } from 'react-router-dom';
import { Box, LoadingBox, translate } from '@lucidlink/uicore';
import { useGetWorkspaceLoginStatus } from '#query-hooks';
export const WorkspaceAuthenticationRouteGuard = ({ children, predicateFn, }) => {
    _react_refresh_temp_2();
    const { workspaceId = '' } = useParams();
    const { query: { data: workspaceLoginStatus, isLoading: isWorkspaceLoginStatusLoading, }, } = useGetWorkspaceLoginStatus(workspaceId);
    if (isWorkspaceLoginStatusLoading) {
        return (_jsx(Box, { align: "center", isFullHeight: true, isFullWidth: true, justify: "center", children: _jsx(LoadingBox, { alt: translate('Checking workspace login status'), "data-testid": "checking-workspace-login-status", isFullHeight: true }) }));
    }
    const predicateResult = predicateFn({
        workspaceId,
        workspaceLoginStatus,
    });
    if (predicateResult.isSuccess) {
        return children;
    }
    return _jsx(Navigate, { to: predicateResult.navigateTo });
};
_react_refresh_temp_1 = WorkspaceAuthenticationRouteGuard;
$RefreshReg$(_react_refresh_temp_1, "WorkspaceAuthenticationRouteGuard");
_react_refresh_temp_2(WorkspaceAuthenticationRouteGuard, "v6OimCTqM99Ob4PBCBXO8JV/8Qg=", false, () => [useParams, useGetWorkspaceLoginStatus]);
